<template>
	<div>
		<router-view v-if="$route.matched.length==3"></router-view>
		<PageHeaderLayout v-if="$route.matched.length==2">
			<div class="main-page-content" style="margin-top: 20px" v-permission:analysis_list>
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline"
						@keyup.enter.native="init">
						<el-form-item label="公司名称">
							<el-input v-model="searchCondition.company_name" placeholder="请输入公司名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="公司类型">
							<el-select v-model="searchCondition.company_type" placeholder="请选择公司类型">
								<el-option v-for="item in companyOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="活跃状态">
							<el-select v-model="searchCondition.activity_level" placeholder="请选择活跃状态" clearable>
								<el-option v-for="item in activityOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="日期" v-show="searchCondition.type=='tomonth'">
							<el-date-picker
							v-model="searchCondition.month"
							type="month"
							placeholder="请选择一个月份"
							format="yyyy-MM"
							value-format="yyyy-MM"
							/>
						</el-form-item>
						<el-form-item label="注册时间" >
							<el-date-picker
							v-model="searchCondition.res_time"
							type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format='yyyy-MM-dd'
							>
							</el-date-picker>
						</el-form-item><el-form-item label="上次登陆时间" >
							<el-date-picker
							v-model="searchCondition.login_time"
							type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format='yyyy-MM-dd'
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton" :disabled="loadingStaus">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<div class="table-head">
					<el-tabs v-model="searchCondition.type" type="card" @tab-click="handleClick">
						<el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index"
							:name="item.name" class="tab-item">
						</el-tab-pane>
					</el-tabs>
					<div id="">
						<el-button type="primary" @click="DataLoad">导出
						</el-button>
					</div>
				</div>
				<tzTable v-permission:money_list ref="apeTable" :data="dataList" :columns="columns2"
					:loading="loadingStaus" :page='pagingData' @pageChange='init' @sortChange='sortChange' :tableProps="{'max-height':'600px'}">
					<template #balance_list='scope'>
						<div v-if="scope.row.balance_list.length">
							<template v-for="(item,index) in scope.row.balance_list" >
								<div v-if="item.channel_name" :key="index">
									<span>{{item.channel_name}}({{getbank(item.yl_bank)}}) :</span>
									<span>{{item.balance_money}}</span>
								</div>
							</template>
						</div>
						<div v-else>-</div>
					</template>
          <template #supplier_name='scope'>
            <div>
              <div v-if="scope.row.is_supplier==1 && scope.row.supplier_name">
                {{scope.row.supplier_name}}
              </div>
              <div v-else>-</div>
            </div>
          </template>
					<template #activity_level='scope'>
						<el-tag size="medium" :type='scope.row.type' effect="dark">{{scope.row.value}}</el-tag>
					</template>
					<template #action='scope'>
						<el-button type="text" @click="showData(scope.row)">数据总览
						</el-button>
					</template>
				</tzTable>
			</div>
		</PageHeaderLayout>

	</div>
</template>

<script>
	import DatePicker from '@/components/DatePicker.vue'
	import PageHeaderLayout from "@/layouts/PageHeaderLayout";
	import ApeTable from "@/components/ApeTable";
	import tzTable from "@/components/tz-table";
	import {
		mapGetters
	} from "vuex";
	export default {
		components: {
			PageHeaderLayout,
			ApeTable,
			tzTable,
			DatePicker
		},
		data() {
			return {
				//搜索
				searchCondition: {
					company_name: '',
					activity_level: '',
					company_type: '1',
					type: 'today',
					month:null,
					res_time:'',
					login_time:''
				},
				sort_condition:{
					sort_login_num:''
				},
				loadingStaus: false,
				companyOptions: [{
					value: '1',
					label: '人资公司'
				}, {
					value: '2',
					label: '用工企业'
				}],
				activityOptions: [{
					value: '',
					label: '全部'
				}, {
					value: '1',
					label: '待激活'
				}, {
					value: '2',
					label: '不活跃'
				}, {
					value: '3',
					label: '活跃'
				}, {
					value: '4',
					label: '非常活跃'
				}, ],

				tabsList: [{
						label: "每日统计",
						name: "today",
					},
					{
						label: "每周统计",
						name: "toweek",
					},
					{
						label: "每月统计",
						name: "tomonth",
					},
				],
				// 分页信息
				pagingData: {
					is_show: true,
					layout: "total, sizes, prev, pager, next, jumper",
					total: 0,
				},
				dataList: [],
				columns2: [{
						label: "上次登陆时间",
						prop: "last_login_time",

					},{
						prop: 'company_name',
						label: '公司名称'
					},
					{prop: 'created_at',
						label: '注册时间'},
					{
						name: 'supplier_name',
						label: '所属运营商',
						empty: '-',
						slot: true,
					},{
						prop: 'login_num',
						label: '登录次数',
						colProps: {
							sortable:'custom'
						},
					}, {
						prop: 'recharge_money',
						label: '充值金额'
					}, {
						colProps: {
							width: 'auto',
							'min-width': '250px'
						},
						slot: true,
						name: 'balance_list',
						label: '余额',
						empty: '0',

					}, {
						type: 'textArray',
						children: [{
								width: '50',
								label: 'BPO:',
								prop: 'hr_project_bpo_add_num'
							},
							{
								width: '50',
								label: 'RPO:',
								prop: 'hr_project_rpo_add_num'
							},
							{
								width: '50',
								label: '灵工:',
								prop: 'hr_project_lg_add_num'
							},
						],
						prop: '',
						label: '新建项目数量'
					},
					{
						label: "新建总项目数",
						prop: "hr_project_add_num",

					},
					{
						label: "新建招聘信息",
						prop: "recruit_task_add_num",

					},
					{
						label: "新增招聘报名人员",
						prop: "employee_enroll_add_num",

					},
					{
						label: "新增入库人才",
						prop: "employee_add_num",

					},
					{
						label: "新增考勤组",
						prop: "attendance_add_num",

					},
					
					{
						colProps: {
							fixed: 'right',
						},
						slot: true,
						name: 'activity_level',
						label: "活跃状态",


					},
					{
						colProps: {
							fixed: 'right',
						},
						slot: true,
						name: 'action',
						label: "操作",
					},
				],
			};
		},

		methods: {
			//获取选中日期的值
			dataSearch(value) {
				this.searchCondition.time_value = value
			},
			//数据导出
			async DataLoad() {
				let {
					items: list
				} = await this.$api.getstatisticsList({
					current_page: 1,
					page_size: 50000,
					...this.getparams(),
				})

				this.downloadLoading = true
				import('@/excel/Export2Excel').then(excel => {
					const tHeader = ['公司名称', '所属运营商' ,'活跃状态', '登陆次数', '充值金额', '余额', 'BPO', 'RPO', '灵工', '新建总项目数', '新建招聘信息', "新增招聘报名人员", "新增入库人才", "新增考勤组", '上次登陆时间','注册时间'
					];
					const data = this.formatJson(this.dataMapInfo(list))
					const time = new Date().getTime() + Math.random() * 1000
					let filename = `API商户${time}`
					excel.export_json_to_excel({
						header: tHeader, //Header Required
						data, //Specific data Required
						filename: filename, //Optional
						autoWidth: true, //Optional
						bookType: this.exportType, //Optional
					})
					this.downloadLoading = false;
				})
			},
			//转换导出数据
			formatJson(jsonData) {
				return jsonData.map(v => {
					let {
						company_name,
						value,
						login_num,
						recharge_money,
						balance_list_value,
						hr_project_bpo_add_num,
						hr_project_rpo_add_num,
						hr_project_lg_add_num,
						hr_project_add_num,
						recruit_task_add_num,
						employee_enroll_add_num,
						employee_add_num,
						attendance_add_num,
						last_login_time,
            is_supplier,
            supplier_name,
			created_at
					} = v
					return [company_name,
          `${(is_supplier==1&&supplier_name)?supplier_name:'-'}`,
						value,
						login_num,
						recharge_money,
						balance_list_value,
						hr_project_bpo_add_num,
						hr_project_rpo_add_num,
						hr_project_lg_add_num,
						hr_project_add_num,
						recruit_task_add_num,
						employee_enroll_add_num,
						employee_add_num,
						attendance_add_num,
						last_login_time,
						created_at
					]
				})
			},
			//数据总览
			showData(row) {
				this.$router.push({
					path: `/dataAnalysis/detail/${row.id}`,
					query: {
						type: this.searchCondition.type,
						company_type: this.searchCondition.company_type
					}
				})
			},
			//获取银行类型
			getbank(type) {
				let value = ''
				switch (type) {
					case 'ws':
						value = '网商银行'
						break;
					case 'sj':
						value = '盛京银行'
						break;
					case 'alipay':
						value = '支付宝'
						break;
					case 'yinling':
						value = '银灵科技'
						break;
					case 'pingan':
						value = '平安银行'
						break;
					case 'wechat':
						value = '微信'
						break;
					case 'wssft':
						value = '网商收付通'
						break;
					default:
						break;
				}
				return value
			},
			// 重置分页
			async resetPage() {
				this.$refs.apeTable.handleCurrentChange()
			},
			//查询	
			searchButton() {
				this.$refs.apeTable.handleCurrentChange()
			},
			dataMapInfo(data) {
				return data.map((item) => {
					
					if (item.activity_level == 1) {
						item.type = 'info'
						item.value = '待激活'
					} else if (item.activity_level == 2) {
						item.type = 'danger'
						item.value = '不活跃'
					} else if (item.activity_level == 3) {
						item.type = ''
						item.value = '活跃'
					} else if (item.activity_level == 4) {
						item.type = 'success'
						item.value = '非常活跃'
					} else {
						item.type = 'danger'
						item.value = '未知' + item.activity_level
					}
					item.balance_list_value=this.mapListToString(item.balance_list,'-')
					return item
				})
			},
			mapListToString(list,empty){
				let string=''
				list.map(item=>{
          let str = item.channel_name?`${item.channel_name}(${this.getbank(item.yl_bank)}) : ${item.balance_money}  \t \r\n `:''
					string+=str
				})
				console.log(string)
				return string||empty
			},
			//点击tab切换
			async handleClick() {
				this.resetPage()
			},
			sortChange({column, prop, order }){
				this.sort_condition.sort_login_num=order
				console.log({column, prop, order })
				this.init('')
			},
			getparams(){
				let parmas={...this.searchCondition}
				let res_time=parmas.res_time
				delete parmas.res_time
				if(res_time){
					parmas.start_time=res_time[0]
					parmas.end_time=res_time[1]
				}
				let login_time=parmas.login_time
				delete parmas.login_time
				if(login_time){
					parmas.last_login_start_time=login_time[0]
					parmas.last_login_end_time=login_time[1]
				}
				return parmas
			},
			//获取列表
			async init(pageData) {
				console.log(pageData)
				let pagingInfo = pageData||{
					page_size: 10,
					current_page: 1
				}
				let params={
					...pagingInfo,
					...this.getparams()
				}
				if(this.sort_condition.sort_login_num){
					params={...params,...this.sort_condition}
				}else{
					delete params.sort_login_num
				}
				this.loadingStaus = true;
				let res = await this.$api.getstatisticsList(params)
				this.dataList = this.dataMapInfo(res.items) || []
				this.pagingData.total = res.total
				this.loadingStaus = false;
			},
		},
		computed: {
			...mapGetters(["userPermissions"]),
		},

		mounted() {
			this.init()
		},
	};
</script>

<style lang="scss" scoped>
	/deep/ .el-tabs__header {
		margin: 0;
	}

	.table-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
